import {
  SEND_CHAT_MESSAGE_INIT,
  SEND_CHAT_MESSAGE_SUCCESS,
  SEND_CHAT_MESSAGE_FAILED,
  GET_CONVERSATIONS_INIT,
  GET_CONVERSATIONS_SUCCESS,
  GET_CONVERSATIONS_FAILED,
  GET_CONVERSATION_INIT,
  GET_CONVERSATION_SUCCESS,
  GET_CONVERSATION_FAILED,
  DELETE_CONVERSATION_INIT,
  DELETE_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION_FAILED,
  RENAME_CONVERSATION_INIT,
  RENAME_CONVERSATION_SUCCESS,
  RENAME_CONVERSATION_FAILED,
  SET_ACTIVE_CONVERSATION,
  CLEAR_CHAT,
  ADD_USER_MESSAGE,
  SUBMIT_FEEDBACK_SUCCESS,
} from "actions/types/chat-types";

const defaultState = {
  conversations: [],
  conversationsTotal: 0,
  activeConversationId: null,
  messages: [],
  sendingMessage: false,
  loadingConversations: false,
  loadingConversation: false,
  lastResponse: null,
};

export default function chatReducer(state = defaultState, action) {
  switch (action.type) {
    case ADD_USER_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.message],
      };

    case SEND_CHAT_MESSAGE_INIT:
      return { ...state, sendingMessage: true, lastResponse: null };
    case SEND_CHAT_MESSAGE_SUCCESS:
      return {
        ...state,
        sendingMessage: false,
        activeConversationId: action.response.conversation_id || state.activeConversationId,
        messages: [
          ...state.messages,
          {
            role: "assistant",
            content: action.response.answer || "",
            answer_blocks: action.response.answer_blocks || null,
            follow_ups: action.response.follow_ups,
            key_metrics: action.response.key_metrics,
            risk_flags: action.response.risk_flags,
            chart: action.response.chart,
            table: action.response.table,
            tables: action.response.tables || null,
            display_mode: action.response.display_mode,
            metadata: action.response.metadata,
            id: action.response.metadata?.message_id || null,
            feedback: null,
          },
        ],
        lastResponse: action.response,
      };
    case SEND_CHAT_MESSAGE_FAILED:
      return {
        ...state,
        sendingMessage: false,
        messages: [
          ...state.messages,
          {
            role: "assistant",
            content: "Sorry, something went wrong. Please try again.",
            isError: true,
          },
        ],
      };

    case GET_CONVERSATIONS_INIT:
      return { ...state, loadingConversations: true };
    case GET_CONVERSATIONS_SUCCESS:
      return {
        ...state,
        loadingConversations: false,
        conversations: action.response.conversations || [],
        conversationsTotal: action.response.total || 0,
      };
    case GET_CONVERSATIONS_FAILED:
      return { ...state, loadingConversations: false };

    case GET_CONVERSATION_INIT:
      return { ...state, loadingConversation: true };
    case GET_CONVERSATION_SUCCESS: {
      const msgs = (action.response.messages || []).map((m) => ({
        role: m.role,
        content: m.content,
        answer_blocks: m.metadata?.answer_blocks || null,
        follow_ups: m.metadata?.follow_ups || null,
        key_metrics: m.metadata?.key_metrics || null,
        risk_flags: m.metadata?.risk_flags || null,
        chart: m.metadata?.chart || null,
        table: m.metadata?.table || null,
        tables: m.metadata?.tables || null,
        display_mode: m.metadata?.display_mode || null,
        metadata: m.metadata || null,
        id: m.id,
        created_at: m.created_at,
        feedback: m.feedback || null,
      }));
      return {
        ...state,
        loadingConversation: false,
        activeConversationId: action.response.id,
        messages: msgs,
      };
    }
    case GET_CONVERSATION_FAILED:
      return { ...state, loadingConversation: false };

    case DELETE_CONVERSATION_INIT:
      return { ...state };
    case DELETE_CONVERSATION_SUCCESS:
      return {
        ...state,
        conversations: state.conversations.filter(
          (c) => c.id !== action.conversationId
        ),
        activeConversationId:
          state.activeConversationId === action.conversationId
            ? null
            : state.activeConversationId,
        messages:
          state.activeConversationId === action.conversationId
            ? []
            : state.messages,
      };
    case DELETE_CONVERSATION_FAILED:
      return { ...state };

    case RENAME_CONVERSATION_INIT:
      return { ...state };
    case RENAME_CONVERSATION_SUCCESS:
      return {
        ...state,
        conversations: state.conversations.map((c) =>
          c.id === action.response.id
            ? { ...c, title: action.response.title }
            : c
        ),
      };
    case RENAME_CONVERSATION_FAILED:
      return { ...state };

    case SET_ACTIVE_CONVERSATION:
      return { ...state, activeConversationId: action.conversationId };

    case SUBMIT_FEEDBACK_SUCCESS:
      return {
        ...state,
        messages: state.messages.map((m) =>
          m.id === action.messageId
            ? { ...m, feedback: action.response }
            : m
        ),
      };

    case CLEAR_CHAT:
      return {
        ...state,
        activeConversationId: null,
        messages: [],
        lastResponse: null,
      };

    default:
      return state;
  }
}
